export default "__VITE_PUBLIC_ASSET__f7ee816a__"